import { FC } from 'react';

import { Categories } from 'models/category.model';
import SeoMeta from 'components/library/SeoMeta';

import { make as OldWallOfCards } from 'components/pages/store/WallOfCards.bs';
import { parse as storeCategoryParse } from 'api/graphql/StoreCategory/Gql__StoreCategory__Decoder.bs';
import { catDataToCatConf, getCategoryBySlug } from 'config/CategoriesConf.bs';

export interface CategoryPageProps {
  readonly pid: string;
  readonly inventory: any;
  readonly categories: Categories;
  readonly storeCategory: any;
}

const CategoryPage: FC<CategoryPageProps> = ({ pid, inventory, categories, storeCategory }) => {
  const categoriesPros = catDataToCatConf(categories.results);
  const category = getCategoryBySlug(pid, categoriesPros);
  const storyCategoryData = storeCategoryParse(storeCategory);
  const topContent = storyCategoryData?.top_content;

  return (
    <>
      {storyCategoryData?.seo_meta ? <SeoMeta meta={storyCategoryData?.seo_meta.VAL} /> : null}
      <OldWallOfCards
        inventoryProps={inventory}
        category={category}
        categories={categoriesPros}
        topContent={topContent}
      />
    </>
  );
};

export default CategoryPage;
